var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "typing-animation" }, [
      _c("div", { staticClass: "dot-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot-3" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }